<template>
  <MissionContainer :header-url="mission.module.config.media_url + mission.module_id + '/thumbnail'">
    <h1 style="margin-bottom: 30px">{{mission.module.config.label}}</h1>

    <div class="Info" v-if="mission.module.config.retard">
      <p>Vous n'avez pas validé cette mission depuis au moins 10 jours.</p>
      <p>Si vous rencontrez des difficultés pour rédiger votre objectif S.M.A.R.T. nous vous conseillons de contacter votre diététicienne directement par messagerie ou en participant à nos tchats hebdomadaires. Vous pouvez aussi consulter votre médiathèque où vous retrouverez vos fiches conseils et vos vidéos.</p>
    </div>

    <div class="ContextBlockSpec">
      <p>Vous avez choisi le défi : Manger plus régulièrement.</p>
      <p>La méthode SMART a été conçue pour vous permettre de définir vous-même des objectifs réalistes et atteignables, pour progresser à votre rythme. SMART ici, signifie :</p>
      <ul>
        <li><b>S</b>pécifique</li>
        <li><b>M</b>esurable</li>
        <li><b>A</b>tteignable</li>
        <li><b>R</b>éaliste</li>
        <li><b>T</b>emporel.</li>
      </ul>
      <p class="mt-3">En validant cette mission vous démarrez votre défi. Assurez-vous que vous êtes prêt avant de commencer. Nous vous donnons rendez-vous dans 10 jours pour faire ensemble le bilan de vos progrès. Dans 3 jours nous vous adresserons une mission intermédiaire qui vous apportera des informations complémentaires, des astuces et des conseils pour agrémenter cet exercice.</p>
    </div>

    <p class="ObjectiveBlockSpec">
      <b class="primary--text">Objectif : </b>
      Définir son objectif SMART et commencer son défi
    </p>

    <div class="InstructionsBlockSpec">
      Pour réaliser cette mission, vous devez :<br/>
      <ol>
        <li>Regarder la vidéo</li>
        <li>Lire la fiche PDF</li>
        <li>Rédiger votre défi SMART en suivant les instructions à chaque écran</li>
        <li>VALIDER la mission</li>
      </ol>
    </div>

    <p>Une fois la mission validée, vous retrouverez votre fiche SMART dans votre Médiathèque.</p>

    <IriadeApplicationMediaBlock :block="{ config: mission.module.config.block_media_defi }"></IriadeApplicationMediaBlock>
    <IriadeApplicationMediaBlock :block="{ config: mission.module.config.block_media_smart }"></IriadeApplicationMediaBlock>

    <IriadeApplicationMediaBlock :block="{ config: mission.module.config.block_media_recettes }"></IriadeApplicationMediaBlock>

    <IriadeApplicationMediaBlock :block="{ config: mission.module.config.block_media_objectif }"></IriadeApplicationMediaBlock>

    <div style="background: #F8F8F8; border-radius: 12px; padding: 55px 25px; margin-bottom: 30px;" class="mt-5">
      <div v-if="ui.step === 'intro'">
        <div>
          <h3>Quel défi voulez-vous vous donner ?</h3>
          <div style="font-style: italic;">Exemple : Je vais manger mieux</div>
          <v-text-field class="mt-4" outlined v-model="missionData.quiz.defiO"></v-text-field>

          <v-btn @click="() => { ui.step = 's'; missionData.quiz.defiS = missionData.quiz.defiO; ui.changed = false; }" :disabled="missionData.quiz.defiO === null">Suite</v-btn>
        </div>
      </div>

      <div v-if="ui.step === 's'">
        <div>Votre défi à l'étape précédente : </div>
        <div class="mb-4">{{missionData.quiz.defiO}}</div>
        <h3>Rendez votre défi <b>Spécifique</b></h3>
        <div style="font-style: italic;">Exemple : Je vais manger plus de légumes frais</div>
        <v-text-field @input="ui.changed = true;" class="mt-4" outlined v-model="missionData.quiz.defiS" :value="missionData.quiz.defiO"></v-text-field>

        <v-btn @click="() => { ui.step = 'm'; missionData.quiz.defiM = missionData.quiz.defiS; ui.changed = false; }" :disabled="!ui.changed">Suite</v-btn>
      </div>

      <div v-if="ui.step === 'm'">
        <div>Votre défi à l'étape précédente : </div>
        <div class="mb-4">{{missionData.quiz.defiS}}</div>
        <h3>Rendez votre défi <b>Mesurable</b></h3>
        <div style="font-style: italic;">Exemple : Je vais manger une portion de légumes frais à chaque repas</div>
        <v-text-field @input="ui.changed = true;" class="mt-4" outlined v-model="missionData.quiz.defiM"></v-text-field>

        <v-btn @click="() => { ui.step = 'a'; missionData.quiz.defiA = missionData.quiz.defiM; ui.changed = false; }" :disabled="!ui.changed">Suite</v-btn>
      </div>

      <div v-if="ui.step === 'a'">
        <div>Votre défi à l'étape précédente : </div>
        <div class="mb-4">{{missionData.quiz.defiM}}</div>
        <h3>Rendez votre défi <b>Atteignable</b></h3>
        <div style="font-style: italic;">Exemple : Je vais commencer par manger une portion de légumes frais au diner</div>
        <v-text-field @input="ui.changed = true;" class="mt-4" outlined v-model="missionData.quiz.defiA"></v-text-field>

        <v-btn @click="() => { ui.step = 'r'; missionData.quiz.defiR = missionData.quiz.defiA; ui.changed = false; }" :disabled="!ui.changed">Suite</v-btn>
      </div>

      <div v-if="ui.step === 'r'">
        <div>Votre défi à l'étape précédente : </div>
        <div class="mb-4">{{missionData.quiz.defiA}}</div>
        <h3>Rendez votre défi <b>Réaliste</b></h3>
        <div style="font-style: italic;">Exemple : Je vais commencer par manger une portion de légumes frais ou surgelé au diner</div>
        <v-text-field @input="ui.changed = true;" class="mt-4" outlined v-model="missionData.quiz.defiR"></v-text-field>

        <v-btn @click="() => { ui.step = 't'; missionData.quiz.defiT = missionData.quiz.defiR; ui.changed = false; }" :disabled="!ui.changed">Suite</v-btn>
      </div>

      <div v-if="ui.step === 't'">
        <div>Votre défi à l'étape précédente : </div>
        <div class="mb-4">{{missionData.quiz.defiR}}</div>
        <h3>Rendez votre défi <b>Temporellement défini</b></h3>
        <div style="font-style: italic;">Exemple : Je vais commencer par manger une portion de légumes frais ou surgelé au diner pendant 1 mois, si cela m’est facile, je ferai de même au déjeuner</div>
        <v-text-field @input="ui.changed = true;" class="mt-4" outlined v-model="missionData.quiz.defiT"></v-text-field>

        <v-btn @click="ui.step = 'fin'" :disabled="!ui.changed">Fin</v-btn>
      </div>

      <div v-if="ui.step === 'fin'">
        <h3>Voici donc votre défi SMART : </h3>
        <div class="mb-4">{{missionData.quiz.defiT}}</div>
        <p>Rendez-vous dans 10 jours pour faire le point sur votre défi !</p>

        <IriadeCheckbox label="Je souhaite que mon objectif SMART soit relu par mon Coach." v-model="missionData.quiz.relecture"></IriadeCheckbox>
        <p v-if="missionData.quiz.relecture">(N'oubliez pas de VALIDER cette mission pour que votre Coach soit alerté de votre demande. Votre défi 10 jours ne commencera qu'après la validation de votre objectif).</p>
        <p v-else>Rendez-vous dans 10 jours pour faire le point sur votre défi !</p>

        <IriadeButton @click="finishMission()" block>Valider la mission</IriadeButton>
      </div>
    </div>
  </MissionContainer>
</template>

<script>
  import api from 'api'
  import FinishMissionButtonBlock from 'components/blocks/FinishMissionButtonBlock'
  import MissionContainer from 'components/blocks/MissionContainer'
  import IriadeApplicationMediaBlock
    from "../../../../../../Iriade/Blocks/IriadeApplicationMediaBlock/IriadeApplicationMediaBlock";

  export default {
    components: {
      IriadeApplicationMediaBlock,
      FinishMissionButtonBlock,
      MissionContainer
    },
    data () {
      return {
        missionData: {
          quiz: {
            defiO: null,
            defiS: null,
            defiM: null,
            defiA: null,
            defiR: null,
            defiT: null,
            relecture: false,
          },
        },
        ui: {
          step: 'intro',
          visiteConfirmee: null,
          changed: false,
        },
      }
    },

    computed: {
    },

    methods: {
      finishMission () {
        this.ui.loading = true
        this.errors = {}

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
          .then(() => {
            this.ui.loading = false
          })
      },
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .Question {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
  .Info {
    background-color: #c0c0c0;
    font-size: 19px;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px
  }
  .ContextBlockSpec {
    font-size: 18px;
    font-weight: 700;
  }
  .ObjectiveBlockSpec {
    font-size: 18px;
    font-weight: 500;
  }
  .Category {
    margin-top: 25px;
  }
  .v-label {
    font-size: 20px

  }
</style>
